<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style lang="less">
	* {
		margin: 0;
		padding: 0;
  }
  body{
    font-family: '宋体';
  }
  .new-content p{
    margin: 14px 0;
  }
</style>
